import * as t from './actionTypes';
import { Action } from '../../common/types/types';

type State = {};

export const initialState = {};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case t.REGISTER_START: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
